module.exports = __webpack_public_path__ + "assets/images/project/head/Son_Heung-min.jpg?v=07773151";